import { BaseBankAccountDTOSchema } from "./bank-accounts.dto.js";
export const UpdateBankAccountInputDTOSchema = BaseBankAccountDTOSchema.omit({
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    isDeleted: true,
});
//# sourceMappingURL=update-bank-account.dto.js.map